module.exports = "/shifts/components/shiftsCheckboxSelector-bac056.html";